
import { Usuario } from "app/models/usuario";
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbUsuario extends AppService {
  abstract getUsuario(): Observable<any>;
  abstract getAllTenantsUsuario(): Observable<any>;
  abstract alterarSenha(alterarSenha: any): Observable<any>;
  abstract recuperarSenhaByEmailAndIntegradorId(email: string, id: number): Observable<any>;
  abstract getCustomSkin(): Observable<any>;
  abstract getUsuarioByEmail(email: string): Observable<any>;
  abstract getUsuarioByPessoaId(id: number, isSigma: boolean): Observable<any>;
  abstract alterarLogin(usuario: Usuario): Observable<any>;
  abstract registrarPrimeiroAcesso(): Observable<any>;
  abstract validarSenha(senha: string): Observable<any>;
  abstract alterarHabilitarMfa(idUsuario: number, habilitarMFA: boolean, motivo: string): Observable<any>;
  abstract getMfaConfig(idUsuario: number): Observable<any>;
}
